import type { PromoteFormViewerFieldsFragment } from '../../shared/api/promoteFormViewerFields.graphql';
import type { PromoteFormData } from '../context';

import { normalizeSavedPaymentMethods } from './normalizeSavedPaymentMethods';

export function normalizeUserData(viewer: PromoteFormViewerFieldsFragment): PromoteFormData['user'] {
	if (!viewer.user) {
		const { firstName, lastName, email } = viewer.guestUserData || { firstName: '', lastName: '', email: '' };
		return {
			id: '',
			email,
			name: `${firstName} ${lastName}`,
			firstName,
			lastName,
			hasPaymentMethod: false,
			hasSubscription: false,
			savedPaymentMethods: [],
		};
	}

	return {
		id: viewer.user.id,
		email: viewer.userProtectedData?.email || '',
		name: viewer.user.displayName,
		firstName: '',
		lastName: '',
		hasPaymentMethod: viewer.user.hasPaymentMethod,
		hasSubscription: !!viewer.user.membership,
		savedPaymentMethods: normalizeSavedPaymentMethods(viewer.userProtectedData?.paymentMethods),
	};
}
